<ng-container *ngIf="config as cfg">
  <app-modal [isOpen]="true" [isFullscreen]="cfg.isFullscreen ?? false" [className]="cfg.className ?? ''" (close)="onClose()">
  <ng-container *ngIf="cfg.type === 'confirm'">
      <div class="p-6 flex flex-col gap-4">
        <div class="flex items-start gap-4">
          <div class="flex h-12 w-12 items-center justify-center rounded-full bg-red-100 text-red-600">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 9v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 17h.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.29 3.86L1.82 18.36C1.29 19.27 2 20.5 3.09 20.5H20.91C22 20.5 22.71 19.27 22.18 18.36L13.71 3.86C12.98 2.59 11.02 2.59 10.29 3.86Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
          <div>
            <h3 class="text-lg font-semibold">{{ cfg.title }}</h3>
            <p class="mt-1 text-sm text-gray-600">{{ cfg.message }}</p>
          </div>
        </div>
        <div class="mt-2 flex justify-end gap-3">
          <app-button variant="outline" size="sm"><button class="inline-flex items-center justify-center gap-2 rounded-lg transition px-4 py-3 text-sm">{{ 'common.cancel' | transloco }}</button></app-button>
          <app-button variant="primary" size="sm"><button (click)="confirmYes()" class="inline-flex items-center justify-center gap-2 rounded-lg transition px-4 py-3 text-sm">{{ 'common.confirm' | transloco }}</button></app-button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="cfg.template">
      <ng-container *ngTemplateOutlet="cfg.template"></ng-container>
    </ng-container>
  </app-modal>
</ng-container>
